module.exports = __webpack_public_path__ + "img/登录验证5.f6dbfdb7.jpg";